<template>
  <div>
    <div class="grid gap-4 py-6 border-t bg-gray-50 md:grid-cols-3 auto-rows-auto lg:grid-cols-5">
      <DatePicker class="col-span-2" color="indigo" mode="dateTime" :minute-increment="5" is-range is24hr v-model="filter.date" :model-config="{ start: { timeAdjust: '00:00:00' }, end: { timeAdjust: '23:59:59' } }">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="flex justify-center">
            <input
              :value="inputValue.start"
              v-on="inputEvents.start"
              class="w-40 form-input prepend"
            />
            <div class="flex items-center justify-center flex-none w-10 border bg-gray-50">
              &rarr;
            </div>
            <input
              :value="inputValue.end"
              v-on="inputEvents.end"
              class="w-40 form-input append"
            />
          </div>
        </template>
      </DatePicker>
    </div>

    <template v-if="report">
      <div v-if="report.rows.length === 0" class="p-8 text-center text-gray-500 rounded-b-lg bg-gray-50">
        No results. Try broadening your query parameters.
      </div>
      <div class="flex flex-col overflow-hidden card" v-else>
        <div class="-my-2 overflow-x-auto cursor-grab" v-dragscroll>
          <div class="inline-block min-w-full py-2 align-middle">
            <div class="overflow-hidden">
              <table class="min-w-full divide-y divide-gray-100">
                <thead>
                  <tr class="border-b">
                    <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase whitespace-nowrap bg-gray-50" v-for="key in keys" :key="key">
                      {{ sentenceCase(key) }}
                    </th>
                  </tr>
                </thead>
                <tbody class="divide-y">
                  <tr class="bg-white group" v-for="row in report.rows" :key="row.tripid">
                    <td class="px-6 py-2 text-sm leading-5 text-gray-900 whitespace-nowrap group-hover:bg-gray-50" v-for="key in keys" :key="key">
                      {{ formatItem(row[key], key) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'
import { sentenceCase } from 'change-case'
import { sub, setMinutes, setHours, formatDuration, formatISO } from 'date-fns'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
  name: 'TripReport',

  directives: {
    dragscroll
  },

  components: {
    DatePicker
  },

  props: {
    report: {
      type: Object
    }
  },

  computed: {
    params () {
      return { 
        filter: this.filter,
      }
    }
  },

  data () {
    return {
      filter: {
        date: {
          start: sub(new Date(), { days: 1 }),
          end: new Date()
        }
      },
      keys: [
        'objectname', 'objectno',
        'drivername', 'driverno', 
        'duration', 'distance',
        'start_odometer', 'end_odometer',
        'start_time', 'end_time', 'idle_time',
        'start_postext',
        'start_formatted_latitude', 'start_formatted_longitude',
        'end_postext', 
        'end_formatted_latitude', 'end_formatted_longitude',
        'avg_speed', 'max_speed'
      ]
      //'start_latitude', 'start_longitude', 
      // 'end_latitude', 'end_longitude', 'end_addrno',
      // 'objectuid',
      // 'driveruid',
      // 'coasting_indicator', 'constant_speed_indicator',  'drivingevents_indicator',  'fuelusage_indicator', 'green_speed_indicator', 'high_revving_indicator',  'idling_indicator', 'optidrive_indicator', 'speeding_indicator', 'tripid', 'tripmode', 
    }
  },

  methods: {
    sentenceCase,

    formatItem (value, key) {
      if (key === 'duration' || key === 'idle_time') {
        return (value / 60).toFixed() + 'm ' + (value % 60) + 's'
      } else if (key === 'distance') {
        return (value / 1000).toFixed(2) + 'km'
      } else if (key === 'start_odometer' || key === 'end_odometer') {
        return (value / 1000).toFixed(2) + 'km'
      } else if (key === 'max_speed' || key === 'avg_speed') {
        return value + 'km/h'
      } else {
        return value
      }
    }
  }
}
</script>